/* eslint-disable @typescript-eslint/interface-name-prefix */
/* eslint-disable react-hooks/exhaustive-deps */
/* 热门车型栏 */
import React, { useRef, useState, useEffect, useCallback } from 'react'
import fetch from 'lib/decorated-fetch'
import classnames from 'classnames'
import Link from 'next/link'
import getUrl from 'lib/url'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import {
  useResponsive,
  IResponsiveType,
  computedResponsive,
} from 'Components/hooks/use-responsive'

import { brandPageConfig, renderBrandItem } from './hot-brand'
import RenderCarList, { pageConfig, RenderCarBox } from './car-list'
import Loading from 'Components/loading'

import RenderItem from './render-item'

interface ISeriesItem {
  cover_url: string
  outter_name: string
  id: number
  info: {
    series_name: string
    series_id: number
    cover_url: string
    brand_name: string
  }
  car_ids: []
  series_status_tag?: object
  new_car_tag?: number
}
interface INavList {
  name: string
  param: string
  query: string
}

const ConditionList: INavList[] = [
  {
    name: '热门车型',
    param: '',
    query: 'x-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '国产',
    param: '&country=0',
    query: 'x-x-0-x-x-x-x-x-x-x-x',
  },
  {
    name: '德系',
    param: '&country=3',
    query: 'x-x-3-x-x-x-x-x-x-x-x',
  },
  {
    name: '日系',
    param: '&country=1',
    query: 'x-x-1-x-x-x-x-x-x-x-x',
  },
  {
    name: '10-15万',
    param: '&price=10,15',
    query: '10,15-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '15-25万',
    param: '&price=15,25',
    query: '15,25-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '25-35万',
    param: '&price=25,35',
    query: '25,35-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '35-50万',
    param: '&price=35,50',
    query: '35,50-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '50万以上',
    param: '&price=50,-1',
    query: '50,!1-x-x-x-x-x-x-x-x-x-x',
  },
]

const ConditionMap = new Map()
ConditionList.forEach((item) => {
  ConditionMap.set(item.param, item.name)
})

interface InnerConfig {
  size: number
  page: number
}
export interface IPageConfig {
  [key: string]: InnerConfig
}
export const DEFAULT_TYPE = 'xl'

export const getPopularModels = async (req: any) => {
  const query = '?source=1&limit=27&brand_count=32'
  const json = await fetch(
    getUrl(
      `/motor/pc/car/brand/get_home_select_series${query}`,
      'motor.pc_car.api'
    ),
    {
      req,
    }
  ).catch((error) => {
    console.error('[fetch] getPopularModels error', error)
    return []
  })
  const data = json?.data || {}
  return data
}

interface IProps {
  popularModels: any
}

export default function PopularModels({ popularModels = {} }: IProps) {
  const timerRef = useRef<any>()
  const srollBoxStyleRef = useRef<HTMLDivElement>(null)
  /* 当前navigation页 */
  const [nav, setNav] = useState('')

  let defaultCarList: any[] = []
  let defualtHotBrand: any[] = []
  if (popularModels && popularModels.car) {
    defaultCarList = [
      popularModels?.car?.series,
      popularModels?.suv?.series,
      popularModels?.other?.series,
    ]
    defualtHotBrand = popularModels?.hot_brand
  }

  /* 每个条件所对应的数据 */
  const [carList, setCarList] = useState<any[]>(defaultCarList)

  // 热门品牌的数据不随着tab变动
  const hotBrand = useRef(defualtHotBrand)

  // 现在是hover时触发加载，使用缓存处理下
  const tempStorage = useRef(new Map())

  const responsive = useResponsive()
  const [responsiveType, setResponsiveType] =
    useState<IResponsiveType>(DEFAULT_TYPE)

  useEffect(() => {
    setResponsiveType(computedResponsive(responsive))
  }, [responsive])

  useEffect(() => {
    let timer: any = null
    const handleResize = () => {
      if (timer) {
        window.clearTimeout(timer)
        timer = null
      }
      timer = window.setTimeout(() => {
        const activeItem = document.querySelector(
          '.j-condition-list li.active'
        ) as HTMLElement
        if (activeItem && srollBoxStyleRef?.current) {
          srollBoxStyleRef.current.style.width = `${activeItem?.offsetWidth}px`
          srollBoxStyleRef.current.style.left = `${activeItem?.offsetLeft}px`
        }
      }, 400)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const hasStorage = useCallback(
    (nav) => {
      if (tempStorage?.current?.has(nav)) {
        setCarList(tempStorage.current.get(nav))
        return true
      }
      return false
    },
    [tempStorage, setCarList]
  )

  useEffect(() => {
    try {
      if (hasStorage(nav)) {
        return
      }

      if (nav) {
        fetchData(nav)
        return
      }

      if (!popularModels || !popularModels?.car) {
        fetchData(nav)
      } else {
        // 默认服务器端请求热门
        tempStorage.current.set(nav, defaultCarList)
      }
    } catch {
      // no-op
    }
  }, [nav])

  /* 获取数据 */
  function fetchData(nav: string) {
    if (hasStorage(nav)) {
      return
    }
    setCarList([])
    const query = `?source=1&limit=27&brand_count=32${nav}`
    fetch(getUrl(`/motor/pc/car/brand/get_home_select_series${query}`), {
      method: 'get',
    }).then((res) => {
      const result = [
        res?.data?.car?.series,
        res?.data?.suv?.series,
        res?.data?.other?.series,
      ]
      if (!hotBrand.current?.length) {
        hotBrand.current = res?.data?.hot_brand
      }
      setCarList(result)
      tempStorage.current.set(nav, result)
    })
  }
  /* 渲染选择条件 */
  function renderCondition() {
    return (
      <ul className="j-condition-list">
        {ConditionList.map((item, index) => (
          <li
            key={`${index}-condition`}
            className={classnames(
              'tw-mr-12 md:tw-mr-25 lg:tw-mr-35 xl:tw-mr-40 2xl:tw-mr-45',
              {
                active: nav === item.param,
              }
            )}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLElement
              timerRef.current = setTimeout(() => {
                if (srollBoxStyleRef?.current) {
                  srollBoxStyleRef.current.style.width = `${target?.offsetWidth}px`
                  srollBoxStyleRef.current.style.left = `${target?.offsetLeft}px`
                }
                setNav(item.param)
                sendTeaCommEvent('hover_event', {
                  event_id: 'select_module_nav',
                  button_name: item.name,
                  module_id: 'select_module',
                })
              }, 200)
            }}
            onMouseLeave={(event) => {
              if (timerRef.current) {
                window.clearTimeout(timerRef.current)
              }
            }}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'select_module_nav',
                button_name: item.name,
                module_id: 'select_module',
              })
            }}
          >
            <Link
              key={item.name}
              href={`/auto/library/${item.query}`}
              as={`/auto/library/${item.query}`}
            >
              <a target="_blank" className="item">
                <span>{item.name}</span>
              </a>
            </Link>
          </li>
        ))}
        <div className="scroll-box" ref={srollBoxStyleRef} />
        <style jsx>
          {`
            ul {
              position: relative;
              margin-bottom: 16px;
              height: 37px;
              margin-left: -10px;
              padding-left: 10px;
              margin-right: -10px;
              padding-right: 10px;
              overflow: hidden;
            }
            ul::before {
              content: '';
              position: absolute;
              left: 7px;
              right: 17px;
              bottom: 0;
              height: 1px;
              background: #e6e8f2;
            }
            li {
              position: relative;
              display: inline-block;
              font-size: 16px;
              height: 36px;
              line-height: 36px;
            }
            .item:hover {
              color: #1f2129;
            }
            li:hover {
              cursor: pointer;
            }
            li:last-child {
              margin-right: 0;
            }
            .active {
              font-weight: 480;
              transform: scale(1.25);
            }
            .scroll-box {
              position: absolute;
              width: 64px;
              height: 2px;
              background: #ffcc32;
              bottom: 0;
              left: 0;
              transform: scaleX(1.25);
              transition: left 0.4s ease-in-out, width 0.4s ease-in-out;
            }
          `}
        </style>
      </ul>
    )
  }

  // TODO 需要添加跳转
  const titleList = ['轿车', 'SUV', '其他']
  const types = ['0', '1', 'x']
  return (
    <div className="popular-model">
      {renderCondition()}
      {carList.length ? (
        <>
          {carList?.length &&
            carList?.map((listItem: any[], index: number) => (
              <RenderItem
                key={index}
                responsiveType={responsiveType}
                listData={listItem}
                index={index}
                navName={titleList[index]}
                url={`/auto/library/x-${types[index]}-x-x-x-x-x-x-x-x-x`}
                pageConfig={pageConfig}
                renderBrandItem={RenderCarBox}
                nav={nav}
                moreType={types[index]}
              />
            ))}
        </>
      ) : (
        <div className="car-list-loading">
          <Loading />
        </div>
      )}
      <RenderItem
        responsiveType={responsiveType}
        listData={hotBrand.current}
        navName={'品牌'}
        pageConfig={brandPageConfig}
        renderBrandItem={renderBrandItem}
        nav={nav}
        moreType={'x'}
      />
      <style jsx>
        {`
          .car-list-loading {
            height: 180px;
            padding-top: 60px;
          }
          .popular-model {
            height: 322px;
            border-top: 0;
            border-radius: 4px;
            background: #fff;
            padding-left: 24px;
            padding-right: 9px;
            padding-top: 12px;
            padding-bottom: 22px;
          }
          .car-list {
            display: flex;
          }
          .car-title {
            width: 45px;
            padding: 10px 0 0 0;
            font-size: 16px;
            color: #1f2129;
          }
          .car-title:hover {
            color: #e62021;
            cursor: pointer;
          }
          .box {
            flex: 1;
            overflow: hidden;
            height: 58px;
            position: relative;
          }
          :global(.popular-model .swiper-slide) {
            max-width: 180px;
          }
          :global(.popular-model .swiper-container) {
            padding: 0 40px;
          }
          :global(.popular-model .swiper-container:before) {
            content: '';
            width: 30px;
            height: 100%;
            position: absolute;
            left: -1px;
            top: 0;
            background: #f2f4fa;
            z-index: 8;
          }
          :global(.popular-model .swiper-container:after) {
            content: '';
            width: 30px;
            height: 100%;
            position: absolute;
            right: -1px;
            top: 0;
            background: #f2f4fa;
            z-index: 8;
          }
          :global(.popular-model .cus-button-next-click) {
            position: absolute;
            font-size: 12px;
            color: #606370;
            right: 10px;
            top: 13px;
            z-index: 9;
          }
          :global(.popular-model .cus-button-next-click:hover) {
            color: #e62021;
            cursor: pointer;
          }
          :global(.popular-model .cus-button-next-click a:after) {
            content: '';
            width: 0;
            height: 0;
            display: inline-block;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #1f2129;
            margin-left: 4px;
            margin-bottom: 1px;
          }
          :global(.popular-model .cus-button-next-click:hover a:after) {
            content: '';
            width: 0;
            height: 0;
            display: inline-block;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #e62021;
            margin-left: 4px;
            margin-bottom: 1px;
          }
        `}
      </style>
    </div>
  )
}
